/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import { url } from 'utils/urls';
// unique elements
import Frame from 'components/frames/frame_container';
import BodyCopy from 'components/shared/bodycopy/bodycopy';
import CTAs from 'components/shared/ctas/ctas';
import Button from 'components/shared/button/button';
import InsticatorLogo from 'components/shared/logo/insticator/insticator_container';
// utils
import { trackEvent } from 'utils/tracking/tracking';
import { refreshAds } from 'utils/ads';
// import Close from 'components/shared/close/close';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/screens/validation/validation_styles';
import { createStyles } from 'utils/styles';
import { preloadStyleImages } from "utils/preloader";
import { isLocalStorageExists } from 'utils/environment';
preloadStyleImages(styles);
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ VALIDATION SCREEN: CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
const ValidationScreen = props => {
    const handleGotItClick = (e) => {
        // trackEvent('click', 'buttonSelected', null, {text: e.target.textContent, target:'close_screen', currentScreen: 'privacy_optin'});
        refreshAds();
        props.displayScreen({ name: 'validation', type: 'full', visible: false, content: null })
    };

    return(
        <div className={`${sheet.classes.validationscreen} validationscreen`}>
            <div className={`validation`}>
                <div className={`dimmer`} />
                <div className={`group`}>
                    <BodyCopy>
                        <ul>
                            {props.email && <li>{`Please enter a valid email address`}</li>}
                            {props.checkboxes && <li>{`Please agree to the terms and conditions`}</li>}
                            {props.duplicate && <li>{`This email address has already been submitted`}</li>}
                        </ul>
                    </BodyCopy>
                    <CTAs type={`inline`}>
                        <Button klass={`white`} onClick={handleGotItClick}>{`Got it`}</Button>
                    </CTAs>
                </div>
            </div>
        </div>
    )
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default ValidationScreen;
